import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { getBranch } from 'utils/app.utils'
import * as UseStyled from 'features/report/useStyled'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import { Box, InputAdornment } from '@mui/material'
import Loading from 'new-components/loading/loading'
import _ from 'lodash'
import FucntionPrint from 'component/Print/print'
import SelectButton from 'new-components/buttons/select-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import MainButton from 'new-components/buttons/main-button'
import IncomeExpenseList from '../IncomeExpense/IncomeExpenseList'
import TextInput from 'new-components/inputs/text-input'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import ComponentApi from 'api/components-api'
import PatientTypesList from './PatientTypesList'
// import IncomeExpenseList from './IncomeExpenseList'
const PatientTypes = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const componentRef = useRef<HTMLDivElement>(null)
    const [branchId, setBranchId] = useState<any>(getBranch())
    const [branches, setBranches] = useState<any[]>([])
    const [branchSelect, setBranchSelect] = useState<number>(getBranch())
    const [rangeDate, setRangeDate] = useState<string[]>([moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
    const [rowCount, setRowCount] = useState<number>(0)
    const [sortBy, setSortBy] = useState<string>('createAt')
    const [sortType, setSortType] = useState<string>('ASC')
    const [fetch, setFetch] = useState(false)
    const [rows, setRows] = useState<any[]>([])
    const [rowsExport, setRowsExport] = useState<any[]>([])
    const [rowsGroup, setRowsGroup] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [patientTypeOption, setPatientTypeOption] = useState<{ name: string, id: any }[]>([])
    const [patientTypeSelect, setPatientTypeSelect] = useState<string[]>([])
    const [search, setSearch] = useState<string>('');
    const [staticCondition, setStaticCondition] = useState({
        page: 1,
        sortBy: sortBy,
        sortType: sortType,
        branchId,
        patientTypeId: patientTypeSelect?.join(',') || ''
    });
    const [pageLimit, setPageLimit] = useState(10)
    const [isExport, setIsExport] = useState(true)
    const verifyPermission = async () => {
        const condition: FindAllReportInterface = {
            page: 1,
            pageLimit: 200
        }
        ReportApi.reportList(condition).then(({ data }) => {
            const check = _.find(data, (val: any) => String(val.reportKey) === 'PATIENT_TYPES') ? true : false
            if (!check) {
                history.push(routeName.report)
                return false
            }
        })
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data.map((item: any) => ({ name: item?.branchName, value: item?.branchId }))))
            .catch((e) => {
                return
            })
        ComponentApi.findAllPatientType(condition).then((resPatientTypes) => {
            if (resPatientTypes.status === 200) {
                const newData = resPatientTypes?.data.map((item: any) => {
                    return { name: item?.patientTypeName, id: item?.patientTypeId }
                })
                setPatientTypeOption(newData)
                setPatientTypeSelect(newData.map((item: any) => item.id))
            }
        })
    }
    useEffect(() => {
        verifyPermission()
    }, [branchId])
    const fetchDF = async (isExport?: boolean) => {
        let condition: any = { ...staticCondition, pageLimit: pageLimit, search: search };
        if (isExport) condition = { ...condition, export: '1' };
        setLoading(true);
        ReportApi.reportPatientTypeOption(condition)
            .then(({ headers, data }) => {
                if (!isExport) {
                    setRows(data?.rows || []);
                    setRowCount(headers['x-total']);
                } else {
                    setIsExport(false)
                    setRowsExport(data?.rows || []);
                    setRowsGroup(data?.group || [])
                }
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setLoading(false);
            });
    };
    const { onDownload } = useDownloadExcel({
        tableExportRef: componentRef.current,
        filename: `${t(`REPORT.REPORT_NAME.PATIENT_TYPES`)}`,
        sheetName: `${t(`REPORT.REPORT_NAME.PATIENT_TYPES`)}`
    })
    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }
    const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)
    const handleChangePage = (val: number) => handlePageChange(val)
    useEffect(() => {
        isExport && fetchDF(true)
    }, [isExport, staticCondition])
    useEffect(() => {
        fetchDF()
    }, [staticCondition, pageLimit])
    const handlePageChange = (newPage: number) => {
        setStaticCondition({
            ...staticCondition,
            page: newPage
        });
    };
    const handleButtonClick = () => {
        const newPatientType = patientTypeSelect.length === patientTypeOption?.length ? [] : patientTypeSelect
        setStaticCondition({
            ...staticCondition,
            page: 1,
            branchId: branchSelect,
            patientTypeId: newPatientType?.join(',') || ''
        });
        setIsExport(true)
    };
    const renderPatientTypeSelect = useCallback((): string => {
        if (patientTypeOption?.length === patientTypeSelect?.length || !patientTypeSelect?.length) {
            return t('ALL')
        }
        const newText = patientTypeSelect.map((item: any) => patientTypeOption.find((obj: any) => obj.id === item)?.name).join(',')
        return newText
    }, [patientTypeOption, patientTypeSelect])
    return (
        <>
            <Card className={'border-0 h-100'}>
                <HeaderCard text={t(`REPORT.REPORT_NAME.PATIENT_TYPES`)} />
                <Card.Body>
                    <Card.Title className={'mb-0'}>
                        <Row className="mx-0">
                            <Col sm={6} md={4} xl={2} className={'pt-2'}>
                                <TextInput
                                    fullWidth
                                    placeholder={t('REPORT.TABLE.PATIENT_TYPES.SEARCH')}
                                    value={search}
                                    onChange={(event) => setSearch(event.target.value)}
                                    inputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" >
                                                <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Col>
                            <Col sm={6} md={4} xl={2} className={'pt-2'}>
                                <SelectInput
                                    label={t('NAV.BRANCH')}
                                    onChange={(e) => setBranchSelect(e.target.value)}
                                    options={branches}
                                    value={branchSelect.toString()}
                                />
                            </Col>
                            <Col sm={6} md={4} xl={2} className={'pt-2 px-1'}>
                                <SelectCheckBoxInput
                                    label={t('REPORT.TABLE.PATIENT.PATIENT_TYPE')}
                                    onChange={(e) => setPatientTypeSelect(e)}
                                    options={[{ name: 'ไม่ระบุประเภทผู้ป่วย', id: '0' }, ...patientTypeOption]}
                                    selected={patientTypeSelect}
                                />
                            </Col>
                            <Col sm={6} md={4} xl={2} className={'pt-2 px-1 d-flex flex-row align-items-center'}>
                                <Box sx={{ maxWidth: '100px', width: '100%', button: { width: '100%' } }}>
                                    <MainButton
                                        onClick={() => {
                                            handleButtonClick()
                                        }}
                                        title={t('INPUT.SEARCH')}
                                        type={'primary'}
                                        variant={'contained'}
                                    />
                                </Box>
                            </Col>
                            <Col md={4} xl={2} className={'d-xl-flex justify-content-xl-end ml-xl-auto pt-2 '}>
                                <UseStyled.DropdownDocument title={t('REGISTER.BUTTON.PRINT_DOCUMENT')} id="dropdown-basic" className="ml-xl-auto">
                                    <UseStyled.DropdownItem onClick={onDownload}>{t('Excel')}</UseStyled.DropdownItem>
                                    <FucntionPrint
                                        content={() => componentRef.current}
                                        removeIfram
                                        trigger={() => <UseStyled.DropdownItem>{t('PDF')}</UseStyled.DropdownItem>}
                                        style={`@page { size: 793.7007874px 1122.519685px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                                    />
                                </UseStyled.DropdownDocument>
                            </Col>
                        </Row>
                    </Card.Title>
                    <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
                        <PatientTypesList
                            page={staticCondition.page}
                            pageLimit={pageLimit}
                            rowCount={rowCount}
                            sortBy={staticCondition.sortBy}
                            sortType={staticCondition.sortType}
                            data={rows}
                            dataExport={rowsExport}
                            rowsGroup={rowsGroup}
                            onRequestSort={onRequestSort}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handleChangePage={handleChangePage}
                            setSortType={setSortType}
                            setSortBy={setSortBy}
                            componentRef={componentRef}
                            branchName={_.get(_.find(branches, { value: branchSelect }), 'name')}
                            rangeDate={rangeDate}
                            patientTypeSelect={renderPatientTypeSelect}
                        />
                    </Box>
                </Card.Body>
                {loading && <Loading />}
            </Card>
        </>
    )
}
export default PatientTypes